import FeatureFlags from './containers/FeatureFlags.jsx';

export default FeatureFlags;
